module.exports = __webpack_public_path__ + "static/media/S (79).e7b374ca.jpg";